import type { Admin, User } from "@prisma/client";
import { posthog } from "posthog-js";
import { useEffect } from "react";
import { useLoaderData } from "react-router";

const usePosthogDistinctIdSync = () => {
  const loaderData = useLoaderData<{
    distinctId: string;
    admin: Admin | undefined;
    user: User | undefined;
  }>();
  const distinctId = loaderData?.distinctId;
  const admin = loaderData?.admin;
  const user = loaderData?.user;
  const isAdmin = !!admin;

  useEffect(() => {
    if (!distinctId) return;
    if (posthog.get_distinct_id() === distinctId) return;
    posthog.identify(distinctId, {
      email: user?.email || admin?.email,
      name: user?.name,
      org_id: user?.orgId,
    });
    posthog.register({
      admin_id: admin?.id,
      admin_email: admin?.email,
      is_impersonated: admin && user,
    });
  }, [admin, distinctId, isAdmin, user]);
};

export { usePosthogDistinctIdSync };
